import React from "react";
import theme from "@monorepo/styles/theme";
import { Box, styled } from "@mui/material";
import { SxProps } from "@mui/system";

interface IStyledPageWrapperProps {
  noJustify?: boolean;
  sx?: SxProps;
}

export const SPageWrapper = styled(Box, { shouldForwardProp: (prop) => prop !== "noJustify" })<IStyledPageWrapperProps>(
  ({ noJustify }) => ({
    rowGap: theme.spacing(5),
    justifyContent: noJustify ? "unset" : "center",
    display: "grid",
    width: "100%",
    marginBottom: theme.spacing(5),
    "& svg": {
      [theme.breakpoints.down("md")]: {
        maxHeight: "360px",
      },
    },
    [theme.breakpoints.up("md")]: {
      maxWidth: "100%",
      "& h1": {
        height: "70px",
        lineHeight: "70px",
        marginBottom: theme.spacing(1),
      },
    },
    [theme.breakpoints.down("xl")]: {
      padding: "0px 10px",
    },
    [theme.breakpoints.up("xl")]: {
      maxWidth: "800px",
    },
    [theme.breakpoints.up("xxl")]: {
      maxWidth: "850px",
    },
  })
);

export const StyledPageWrapper: React.FC<IStyledPageWrapperProps> = ({ children, ...rest }) => {
  return <SPageWrapper {...rest}>{children}</SPageWrapper>;
};
